import { useEffect, useRef, useState } from 'react';

const AdSenseComponent = () => {
  const adRef = useRef(null);
  const [isAdLoaded, setIsAdLoaded] = useState(true); // por defecto, se muestra

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (adRef.current && adRef.current.offsetHeight === 0) {
        setIsAdLoaded(false); // Oculta si no se cargó
      }
    }, 3000); // Espera 3 segundos

    try {
      if (window.adsbygoogle && process.env.NODE_ENV !== 'development') {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error('Adsense error', e);
      setIsAdLoaded(false); // Error => oculta
    }

    return () => clearTimeout(timeout);
  }, []);

  if (!isAdLoaded) return null;

  return (
    <ins
      className="adsbygoogle"
      ref={adRef}
      style={{ display: 'block' }}
      data-ad-client="ca-pub-1983956467495395"
      data-ad-slot="1046213070"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  );
};

export default AdSenseComponent;
